// extracted by mini-css-extract-plugin
module.exports = {"container":"DashboardView_container__20utN","spinner":"DashboardView_spinner__4SGh6"};